import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

interface ZoneToggleProps {
  showMyZoneOnly: boolean;
  onToggleChange: (checked: boolean) => void;
}

export const ZoneToggle = ({ showMyZoneOnly, onToggleChange }: ZoneToggleProps) => {
  return (
    <Card className="border-none h-full" style={{ backgroundColor: '#e0F2Eb' }}>
      <CardContent className="p-2 h-full flex items-center">
        <div className="flex items-center justify-between w-full">
          <Label htmlFor="zone-toggle" className="text-xs font-medium leading-tight" style={{ color: '#30565c' }}>
            Farms in my climate zone
          </Label>
          <Switch
            id="zone-toggle"
            checked={showMyZoneOnly}
            onCheckedChange={onToggleChange}
            className="scale-75 ml-2"
          />
        </div>
      </CardContent>
    </Card>
  );
};